import React from "react";

const Gallery = () => {   
    return (
        <section id="Gallery" style={{ padding: "50px 0" }}>
            <div className="container">
                <h1 className="text-center" data-aos="zoom-in">GALLERY</h1>
                <div className="gallery-grid">
                    <div>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/fdp-4.jpeg"}
                            alt="An Oriantation "
                        />
                    </div>
                    <div>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/fdp-3.jpeg"}
                            alt="An Oriantation "
                        />
                    </div>
                    <div>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/fdp-2.jpeg"}
                            alt="An Oriantation "
                        />
                    </div>
                    <div>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/fdp-1.jpeg"}
                            alt="An Oriantation "
                        />
                    </div>
                    <div>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/donate2.jpeg"}
                            alt="An Oriantation "
                        />
                    </div>
                    <div>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/donate-1.jpeg"}
                            alt="An Oriantation "
                        />
                    </div>
                <div>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/orentation-news.jpeg"}
                            alt="An Oriantation "
                        />
                    </div>
                    <div>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/channel.jpeg"}
                            alt="Channel"
                        />                 
                    </div>
                    <div>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/donate.jpeg"}
                            alt="Donation"
                        />
                    </div>
                    <div>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/INTI.jpeg"}
                            alt="A conference at INTI"
                        />
                    </div>
                    <div>
                        <video autoPlay loop muted playsInline>
                            <source src={"/assets/videos/cybersecurity.mp4"} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/islamic_finance_Meezan.jpg"}
                            alt="Islamic Finance"
                        />
                    </div>
                    <div>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/event2.jpeg"}
                            alt="Event 2"
                        />
                    </div>
                    <div>
                        <video autoPlay loop muted playsInline>
                            <source src={"/assets/videos/World_Suicide_Presentation_Day.mp4"} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/event1.jpeg"}
                            alt="Event 1"
                        />
                    </div>
                    <div>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/event11.jpg"}
                            alt="Event 11"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Gallery;
